import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import { PressableField } from "../Pressable";
export var InputGroupContext = React.createContext({});

var InputGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(InputGroup, _React$Component);

  var _super = _createSuper(InputGroup);

  function InputGroup() {
    _classCallCheck(this, InputGroup);

    return _super.apply(this, arguments);
  }

  _createClass(InputGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          direction = _this$props.direction,
          disabled = _this$props.disabled,
          invalid = _this$props.invalid,
          size = _this$props.size,
          width = _this$props.width,
          wrap = _this$props.wrap;
      var classes = classNames('InputGroup', {
        'InputGroup--direction--horizontal': direction === 'horizontal',
        'InputGroup--direction--vertical': direction === 'vertical'
      }, className, {
        'Is--disabled': disabled
      });
      var renderableChildren = React.Children.toArray(children);
      var firstChild = 0;
      var lastChild = React.Children.count(renderableChildren) - 1;
      var items = React.Children.map(renderableChildren, function (child, i) {
        var alignSelfValue = 'stretch';
        var flexGrowValue = 1;

        if (direction === 'horizontal' && child && child.props && child.props.width !== 'maximized') {
          alignSelfValue = 'flex-start';
          flexGrowValue = 0;
        }

        var radiusValue = 'none';

        if (direction === 'horizontal' && i === firstChild) {
          radiusValue = 'left';
        } else if (i === firstChild) {
          radiusValue = 'top';
        } else if (direction === 'horizontal' && i === lastChild) {
          radiusValue = 'right';
        } else if (i === lastChild) {
          radiusValue = 'bottom';
        }

        return /*#__PURE__*/React.createElement(Box, {
          className: "InputGroup-item",
          key: child.key,
          flex: direction === 'horizontal',
          flexBasis: "auto",
          flexGrow: flexGrowValue,
          flexShrink: 1,
          style: {
            alignSelf: alignSelfValue
          }
        }, /*#__PURE__*/React.createElement(InputGroupContext.Provider, {
          value: {
            inputGroupClassName: 'InputGroup-pressable',
            disabled: disabled,
            invalid: invalid,
            size: size,
            radius: radiusValue,
            width: direction === 'vertical' ? 'maximized' : undefined
          }
        }, child));
      });
      var widthValue = width;
      var directionValue = direction === 'vertical' ? 'column' : 'row';
      return /*#__PURE__*/React.createElement(PressableField, {
        className: classes,
        ghost: true,
        size: size,
        width: widthValue
      }, /*#__PURE__*/React.createElement(Box, {
        className: "InputGroup-container",
        flex: {
          direction: directionValue,
          wrap: wrap ? 'wrap' : 'nowrap'
        }
      }, items));
    }
  }]);

  return InputGroup;
}(React.Component);

InputGroup.defaultProps = {
  direction: 'vertical',
  wrap: true
};
export default InputGroup;